import React from 'react';
import { Picker } from '../../../BeeDatePicker.const';
import { usePickerContext } from '../../../contexts/PickerContext/PickerContext';
import { convertToTwoDigitsString } from '../../../helpers/convertToTwoDigitsString';
import { isDatePickerFormFilled } from '../../../helpers/isDatePickerFormFilled';
import { DAY_LENGTH, DAYS } from '../../RenderPicker';
import { Placeholder } from '../DateForm.const';
import { StyledInput } from '../DateForm.styled';
import { DateInputProps } from '../DateForm.types';
import { inputFocus } from '../DateForm.utils';

export const DayInput: React.FC<DateInputProps> = ({
  isVisible,
  setVisiblePicker,
}) => {
  const {
    state: { date, dayRef, monthRef, yearRef, tabIndex, readOnly },
    dispatch,
  } = usePickerContext();

  const handleDayChange = React.useCallback(
    (event: React.ChangeEvent<HTMLInputElement>): void => {
      const { value, maxLength } = event.target;

      if (Number(value) > DAYS) {
        return;
      }

      dispatch({
        type: 'SET_DATE',
        payload: {
          day: value.replace(/\D/g, ''),
        },
      });

      if (value.length !== maxLength) {
        return;
      }

      if (
        isDatePickerFormFilled({
          day: value,
          month: monthRef.current?.value,
          year: yearRef.current?.value,
        })
      ) {
        dayRef.current?.blur();
        dispatch({ type: 'SET_VISIBLE_PICKER', payload: null });
      } else {
        inputFocus(dayRef, monthRef, yearRef);
      }
    },
    [dayRef, monthRef, yearRef, dispatch],
  );

  const handleBlur = React.useCallback(
    (event: React.FocusEvent<HTMLInputElement>) => {
      const { value } = event.target;
      dispatch({
        type: 'SET_DATE',
        payload: {
          day: value !== '' ? convertToTwoDigitsString(value) : '',
        },
      });
    },
    [dispatch],
  );

  return (
    <StyledInput
      autoComplete={'off'}
      name={Picker.DAY}
      maxLength={DAY_LENGTH}
      placeholder={isVisible ? Placeholder.DAY : undefined}
      value={date.day}
      ref={dayRef}
      tabIndex={tabIndex}
      readOnly={readOnly}
      disabled={readOnly}
      onChange={handleDayChange}
      onBlur={handleBlur}
      onClick={setVisiblePicker}
      onFocus={setVisiblePicker}
    />
  );
};
